import * as AsyncActions from './async';
import { mailingSlice } from './slice';

export * from './mailing';
export * from './state';

const Actions = mailingSlice.actions;
const Reducer = mailingSlice.reducer;

export { Reducer, Actions, AsyncActions };
